export const MODULES = {
  PERSONAL_INFO: 'personal_info',
  REGISTRATION_AND_LOGIN: 'registrationAndLogin',
  ENROLLMENT_AND_BALANCES: 'Enrollment_balances',
  EXPENSE_DETAILS: 'expense_details',
  DOCUMENTS: 'documents',
  ACTIVITY_LOG: 'activity_log',
  CARDS: 'cards',
  DEPENDENTS: 'dependents',
  BENEFICIARIES: 'beneficiaries',
  COMMUNICATIONS: 'Communications',
  LOGIN_HISTORY: 'login_history',
  DANGER_ZONE: 'dangerZone',
};
export const employeeConfigModules = {
  [MODULES.PERSONAL_INFO]: 'Personal Information',
  [MODULES.REGISTRATION_AND_LOGIN]: 'Registration & Login',
  [MODULES.ENROLLMENT_AND_BALANCES]: 'Enrollment & Balances',
  [MODULES.EXPENSE_DETAILS]: 'Expense Details',
  [MODULES.DOCUMENTS]: 'Documents',
  [MODULES.CARDS]: 'Cards',
  [MODULES.DEPENDENTS]: 'Dependents',
  [MODULES.BENEFICIARIES]: 'Beneficiaries',
  [MODULES.COMMUNICATIONS]: 'Communications',
  [MODULES.LOGIN_HISTORY]: 'Authentication History',
  [MODULES.ACTIVITY_LOG]: 'Activity Log',
  [MODULES.DANGER_ZONE]: 'Danger Zone',
};

interface Args {
  exclude?: string[];
  hasCards?: boolean;
  isContainNotificationCenter?: boolean;
  isContainEmail?: boolean;
}

export const useEmployeeModules = (args?: Args) => Object
  .keys(employeeConfigModules)
  .filter((anchorId) => !((!args?.isContainNotificationCenter && !args?.isContainEmail)
    && anchorId === MODULES.COMMUNICATIONS))
  .filter((anchorId) => !(!args?.hasCards && anchorId === MODULES.CARDS))
  .reduce((map, anchorId) => {
    if (args?.exclude && args.exclude.includes(anchorId)) {
      return map;
    }
    return ({
      ...map,
      [anchorId]: {
        title: employeeConfigModules[anchorId],
      },
    });
  }, {});

export default useEmployeeModules;
